import { store } from '@/redux/store'

import { feedWeb3Api } from '../feed/feed.w3api'
import { w3Api } from '../w3Api'
import { postTypeCre } from './post.type'
import { profileApiW3 } from '../profile/profileW3'

export const PostEndpoints = {
  uploadsImg: `/files/upload`,
  post: '/post',
  update: '/post/:postId',
}

const postApiW3 = w3Api.injectEndpoints({
  endpoints: (build) => ({
    uploadsIMG: build.mutation<any, any>({
      query: (args) => {
        return {
          url: PostEndpoints.uploadsImg,
          method: 'POST',
          body: args,
        }
      },
    }),
    upPosts: build.mutation<any, postTypeCre>({
      query: (args) => {
        return {
          url: PostEndpoints.post,
          method: 'POST',
          body: args,
        }
      },
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data: createdPost } = await queryFulfilled

          if (createdPost) {
            const space = createdPost.space
            const newData = {
              ...createdPost,
              creatorId: space?.id || createdPost.creator?.id,
              avatarImage: space?.profileImageUrl || createdPost.creator?.avatarImage || '',
              priceBuyKey: createdPost.creator?.priceBuyKey || 0,
              nickname: createdPost.creator?.nickname || '',
              postId: createdPost.id,
              role: createdPost.creator?.role,
              postAs: space ? 'SPACE' : 'USER',
            }

            // newfeed
            dispatch(
              feedWeb3Api.util.updateQueryData(
                'getFeed',
                { page: 1, size: 6, searchType: 'all', sort: 'DESC' },
                (draft) => {
                  if (draft.data) {
                    draft.data.unshift(newData)
                  }
                },
              ),
            )

            // profile
            const state = store.getState()
            const spaceActive = state.root.settings.spaceActive
            const authId = state.root?.auth?.user?.id || ''

            if (spaceActive) {
              dispatch(
                profileApiW3.util.updateQueryData(
                  'getPostBuyUser',
                  {
                    page: 1,
                    size: 6,
                    searchType: 'space',
                    sort: 'DESC',
                    creatorId: spaceActive,
                  },
                  (draft) => {
                    if (draft.data) {
                      draft.data.unshift(newData)
                    }
                  },
                ),
              )
            } else if (authId) {
              dispatch(
                profileApiW3.util.updateQueryData(
                  'getPostBuyUser',
                  {
                    page: 1,
                    size: 6,
                    searchType: 'creator',
                    sort: 'DESC',
                    creatorId: authId,
                  },
                  (draft) => {
                    if (draft.data) {
                      draft.data.unshift(newData)
                    }
                  },
                ),
              )
            }
          }
        } catch (error) {
          console.error('Failed to update cache:', error)
        }
      },
    }),

    editPost: build.mutation<any, postTypeCre & { id: string }>({
      query: (args) => {
        return {
          url: PostEndpoints.update.replace(':postId', args.id),
          method: 'PUT',
          body: args,
        }
      },
    }),

    deletePost: build.mutation<any, string>({
      query: (args) => {
        return {
          url: PostEndpoints.update.replace(':postId', args),
          method: 'DELETE',
        }
      },
    }),
  }),
  overrideExisting: true,
})

export const { useUploadsIMGMutation, useUpPostsMutation, useEditPostMutation, useDeletePostMutation } = postApiW3
